
import { formApiService } from '@/services/form-api.service'

const state = () => ({
    isLoading: false,
    //resellerId: null,
    //emailAddress: null,
    exists: false,
    webUser: null,
    webUserClaims: null,
    exceptions: []
});


const getters = {
    userExists: state => state.exists,
    webUser: state => state.webUser,
    webUserClaims: state => state.webUserClaims
};


const mutations = {
    LOADING(state, payload) {
        state.isLoading = payload
    },
    //SET_RESELLER_ID(state, payload) {
    //    state.resellerId = payload
    //},
    //SET_EMAIL_ADDRESS(state, payload) {
    //    state.emailAddress = payload
    //},
    SET_EXISTS(state, payload) {
        state.exists = payload.exists
        state.webUser = payload.webUser
        state.webUserClaims = payload.webUserClaims
    },
    SET_WEB_USER(state, payload) {
        state.webUser = payload
    },
    ADD_EXCEPTION(state, payload) {
        state.exceptions.push(payload)
    }
};


const actions = {
    checkUserExists({ commit }, payload) {
        commit('LOADING', true)
        formApiService.formUserExists(payload)
            .then((response) => {
                let data = response.data
                commit('SET_EXISTS', data.data)
            })
            .catch((error) => {
                commit('ADD_EXCEPTION', error)
            })
            .finally(() => { commit('LOADING', false) })
    },
    createUser({ commit, dispatch }, payload) {
        commit('LOADING', true)
        formApiService.formUserCreate(payload)
            .then((response) => {
                let { data, messages } = response.data
                if (data) {
                    commit('SET_EXISTS', { exists: true, webUser: data })
                }

                if (messages) {
                    dispatch('notificationModule/toast', messages[0].body, { root: true })
                }
            })
            .catch((error) => {
                commit('ADD_EXCEPTION', error)
            })
            .finally(() => { commit('LOADING', false) })
    },
    assignUserToClaim({ commit, dispatch }, payload) {
        commit('LOADING', true)
        formApiService.formUserAssignToClaim(payload)
            .then((response) => {
                let { data, messages } = response.data
                if (data) {
                    commit('SET_EXISTS', { exists: false, webUser: null })
                    commit('setSelectedClaimEx', data, { root: true })
                }

                if (messages) {
                    for (let i = 0; i < messages.length - 1; i++) {
                        dispatch('notificationModule/toast', messages[i].body, { root: true })
                    }
                }
            })
            .catch((error) => {
                commit('ADD_EXCEPTION', error)
            })
            .finally(() => { commit('LOADING', false) })
    },
    createAssignUserToClaim({ commit, dispatch }, payload) {
        commit('LOADING', true)
        formApiService.formUserCreateAssignToClaim(payload)
            .then((response) => {
                let { data, messages } = response.data
                if (data) {
                    commit('SET_EXISTS', { exists: false, webUser: null })
                    commit('setSelectedClaimEx', data, { root: true })
                }

                if (messages) {
                    for (let i = 0; i < messages.length - 1; i++) {
                        dispatch('notificationModule/toast', messages[i].body, { root: true })
                    }
                }
            })
            .catch((error) => {
                commit('ADD_EXCEPTION', error)
            })
            .finally(() => { commit('LOADING', false) })
    },
    async createAssignUserToClaimAsync({ commit, dispatch }, payload) {
        return new Promise(async (resolve, reject) => {
            try {
                let response = await formApiService.formUserCreateAssignToClaim(payload)
                if (response) {
                    console.log('-r: ', response)
                    let { data, messages } = response.data
                    console.log('-d: ', data)
                    console.log('-m: ', messages)
                    if (data) {
                        commit('SET_EXISTS', { exists: false, webUser: null })
                        //commit('setSelectedClaimEx', data, { root: true }) // What's changed?!  Only user id, can we update just that?
                        let { userId, webUserEmail } = data
                        commit('setClaimUserIdEmail', { userId, webUserEmail }, { root: true })
                    }

                    if (messages) {
                        for (let i = 0; i < messages.length - 1; i++) {
                            dispatch('notificationModule/toast', messages[i].body, { root: true })
                        }
                    }
                }
                resolve(response)
            }
            catch (err) {
                reject()
            }
        })

        commit('LOADING', true)
        formApiService.formUserCreateAssignToClaim(payload)
            .then((response) => {
                let { data, messages } = response.data
                if (data) {
                    commit('SET_EXISTS', { exists: false, webUser: null })
                    commit('setSelectedClaimEx', data, { root: true })
                }

                if (messages) {
                    for (let i = 0; i < messages.length - 1; i++) {
                        dispatch('notificationModule/toast', messages[i].body, { root: true })
                    }
                }
            })
            .catch((error) => {
                commit('ADD_EXCEPTION', error)
            })
            .finally(() => { commit('LOADING', false) })
    }
};


export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}